import { useState, useEffect, useRef } from "react";
import { list } from "../../../../Services/branchService";
import { getClientData, findFromStake, deletestake, updateStakeholder, update, get } from "../../../../Services/clientService";
import _ from "lodash";
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import { Dialog } from "primereact/dialog";
import CheckboxElement from "../../../../Components/UiComponents/CheckboxElement";
import { useForm } from 'react-hook-form';
import CalendarElement from '../../../../Components/UiComponents/CalendarElement';
import InputTextElement from '../../../../Components/UiComponents/InputTextElement';
import { Accordion, AccordionTab } from 'primereact/accordion';
import RadioElement from "../../../../Components/UiComponents/RadioElement";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import Loader from "../../../../Components/UiComponents/Loader";

export default function LinkStakeholder(props) {
    const { register, formState: setValue, trigger } = useForm();
    const [branchId, setBranchId] = useState();
    const [branchDetails, setBranchDetails] = useState();
    const [stakeholderDetails, setStakeholdersDetails] = useState();
    const [isModelOpen, setModelOpen] = useState(false);
    const [checkedCheckboxes, setCheckedCheckboxes] = useState({});
    const [selectedStakeholders, setSelectedStakeholders] = useState([]);
    const [checkedForRemoval, setCheckedForRemoval] = useState({});
    const [currentIndex, setCurrentIndex] = useState(0);
    const [newModule, setNewModule] = useState({});
    const [isSave, setIsSave] = useState(false);
    const [clientData, setClientData] = useState({});
    const [id, setId] = useState();
    const [loading, setLoading] = useState(false);
    const [currentStakeholderIndex, setCurrentStakeholderIndex] = useState(false);

    const toastRef = useRef();

    useEffect(() => {
        getBranchList();
        getStakeData();
    }, [props?.customerId]);

    useEffect(() => {
        if (branchId && selectedStakeholders) {
            getAllStakeholders();
        }
    }, [branchId, selectedStakeholders]);
    useEffect(() => {
        if (props.branch) {
            cliData();
        }
    }, [props.clientId, props.branch])
    useEffect(() => {
        if (clientData && id) {
            saveStakeholder()
        }
    }, [clientData, id]);

    useEffect(() => {
        if (props.linkStakeholderData?.clientSectionsLinkStakeholder) {
            let obj1 = _.find(props.linkStakeholderData?.clientSectionsLinkStakeholder, { section_name: "Stakeholder Overview" })?.display_name;
            let obj2 = _.find(props.linkStakeholderData?.clientSectionsLinkStakeholder, { section_name: "Stakeholder Service Team" })?.display_name;
            let obj3 = _.find(props.linkStakeholderData?.clientSectionsLinkStakeholder, { section_name: "ESG Value Creation Plan Summary" })?.display_name;
            let obj4 = _.find(props.linkStakeholderData?.clientSectionsLinkStakeholder, { section_name: "Commercial Insights" })?.display_name

            let combined = { obj1, obj2, obj3, obj4 };
            setNewModule(combined)
        }

    }, [props.linkStakeholderData?.clientSectionsLinkStakeholder])

    const getStakeData = async () => {
        try {
          setLoading(true); 
      
          // Fetch stakeholder data based on clientId
          const res = await findFromStake(props.clientId);
      
          // Check if the response contains data
          if (res && res.data) {
            setSelectedStakeholders(res.data); // Update state with fetched data
          } else {
            toastRef.current.showToast({
                type: "error",
                message: "No data found for the provided client ID."
              });
          }
        } catch (error) {
          // Handle any errors during the API request
          toastRef.current.showToast({
            type: "error",
            message: "Failed to fetch stakeholder data. Please try again or contact Admin."
          });
        } finally {
          setLoading(false); 
        }
      };
      
      const cliData = async () => {
        try {
          // Check if required props are present
          if (props.clientId && props.customerId && props.branch) {
            setLoading(true); // Start loading spinner
            
            // Fetch client data
            const res = await get(props.clientId, props.customerId, props.branch);
            
            // Check if the response contains client data
            if (res && res.data && res.data.client && res.data.client.length > 0) {
              const cliData = res.data.client[0];
              setClientData(cliData);
              props.getData(cliData);
            } else {
              // Handle case where client data is not found
              toastRef.current.showToast({
                type: "warning",
                message: "No client data found."
              });
            }
          }
        } catch (error) {
          // Handle errors during the API request
          toastRef.current.showToast({
            type: "error",
            message: "Failed to fetch client data. Please try again or contact Admin."
          });
        } finally {
          setLoading(false); 
        }
      };
      

    const loadAssociatedStakeholders = () => {
        setCheckedCheckboxes({});
        setModelOpen(true);
    }

    const closeProgrammDialog = () => {
        setModelOpen(false);
    };


    // Function to fetch customer fields data from the server
    const getBranchList = async () => {
        if (props?.customerId !== null) {
          try {
            setLoading(true);
      
            // Fetch branch data from the server
            const customerDataResponse = await list(props?.customerId, 'branch_name', -1);
      
            if (customerDataResponse?.data?.branch?.length > 0) {
              setBranchDetails(customerDataResponse.data.branch);
              setBranchId(customerDataResponse.data.branch[0]?._id);
            } else {
              toastRef.current.showToast({
                type: 'warning',
                message: 'No branches found for the customer.'
              });
            }
      
            setLoading(false); 
          } catch (error) {
            setLoading(false); 
      
            toastRef.current.showToast({
              type: 'error',
              message: 'Error fetching branch details. Please try again or contact Admin.'
            });
          }
        } 
      };
      

      const getAllStakeholders = async () => {
        try {
          setLoading(true); // Start loading spinner
      
          // Fetch client data with customerId and branchDetails
          const res = await getClientData(props.customerId, branchDetails);
      
          // Set the stakeholder details with the response data
          setStakeholdersDetails(res);
      
          // Get the current stakeholder index based on the response
          getCurrentStakeholderIndex(res);
      
        } catch (error) {
          // Handle errors during the API request
          toastRef.current.showToast({
            type: "error",
            message: "Failed to fetch stakeholders. Please try again or contact Admin.",
          });
        } finally {
          setLoading(false); 
        }
      };
      

    const handleCheckboxChange = (id, isChecked) => {
        setCheckedCheckboxes(prevState => ({
            ...prevState,
            [id]: isChecked
        }));
    };
    const saveStakeholder = async () => {
        if (props.clientId && id) {
            try {
                setLoading(true); 
                // Update stakeholder
                const res = await updateStakeholder(props.clientId, id);
                await updateStakeholder(id, props.clientId);
                if (res && res.data.success) {
                    // Success logic can be added here if needed
                } else {
                    toastRef.current.showToast({
                        type: 'error',
                        message: res?.data?.message || 'Failed to update stakeholder.'
                    });
                }
    
                // Update client data
                const response = await update(props.clientId, clientData);
                if (response && response.data.success) {
                    toastRef.current.showToast({
                        type: 'success',
                        message: response.data.message
                    });
                } else {
                    toastRef.current.showToast({
                        type: 'error',
                        message: response?.data?.message || 'Failed to update client data.'
                    });
                }
    
                // Reset state and fetch updated data
                setIsSave(false);
                getStakeData();
                cliData();
                setId('');
    
            } catch (error) {
                // Handle errors during the process
                toastRef.current.showToast({
                    type: 'error',
                    message: 'An error occurred while saving stakeholder data. Please try again.'
                });
            } finally {
                setLoading(false);
            }
        } else {
            // Handle case where clientId or id is not provided
            toastRef.current.showToast({
                type: 'error',
                message: 'Client ID or Stakeholder ID is missing.'
            });
        }
    };
    

    const handleAddSelectedStakeholders = async () => {
        const selected = Object.keys(checkedCheckboxes).filter(key => checkedCheckboxes[key]);
        if (selected.length > 0) {
            const selectedStakeholdersDetails = stakeholderDetails?.data.filter(unit => selected.includes(unit._id.toString()));

            const existingStakeholderseqs = new Set(selectedStakeholders.map(unit => unit._id));

            const newStakeholders = selectedStakeholdersDetails.filter(unit => !existingStakeholderseqs.has(unit._id));



            setIsSave(true)
            newStakeholders.forEach(async (stakeholder) => {
                let id = stakeholder._id
                setId(id)
                setClientData(prevState => ({
                    ...prevState,
                    // stakeholders: [...(prevState.stakeholders || []), id]
                    stakeholders: [...prevState.stakeholders, id]
                }));

                // const res = await updateStakeholder(props.clientId, stakeholder._id);
                const res = await updateStakeholder(stakeholder._id, props.clientId);
                if (res && res.data.success) {
                    // Success logic can be added here if needed
                } else {
                    toastRef.current.showToast({
                        type: 'error',
                        message: res?.data?.message || 'Failed to update stakeholder.'
                    });
                }
            })

            // const newStakeholdersArray = newStakeholders.map(unit => ({
            //     _id: unit._id,
            //     client_name: unit.client_name
            // }));

            // setSelectedStakeholders(prevState => [
            //     ...prevState,
            //     ...newStakeholdersArray
            // ]);

            setModelOpen(false);
            toastRef.current.showToast({
                type: 'success',
                message: _.find(props.linkStakeholderData?.clientAssociatedStakeholderFrame, { table_name: "Associated Stakeholder" })?.display_name + " Successfully"
            });
        } else {
            setModelOpen(true);
            toastRef.current.showToast({
                type: 'error',
                message: "Atleast One " + props.linkStakeholderData.stakeholderLinkTab + " Should Be Selected"
            });
        }
    };

    const handleRemovalCheckboxChange = (id, isChecked) => {
        setCheckedForRemoval(prevState => ({
            ...prevState,
            [id]: isChecked
        }));
    };

    const removeProgram = async (data) => {
        try {
          setLoading(true); 
      
          // Call API to delete the stakeholder
          const res = await deletestake(props.clientId, data._id);
      
          if (res && res.data.success === true) {
            toastRef.current.showToast({
              type: 'success',
              message: res.data.message,
            });
          } else {
            toastRef.current.showToast({
              type: 'error',
              message: res?.data?.message || "Failed to remove the program. Please try again.",
            });
          }
      
          // Refresh stakeholder data after deletion
          await getStakeData();
          await cliData();
        } catch (error) {
          // Handle any errors that may occur during the API call
          toastRef.current.showToast({
            type: 'error',
            message: "An error occurred while removing the program. Please try again or contact Admin.",
          });
        } finally {
          setLoading(false); 
        }
      };
      

    const removeAssociatedStakeholders = () => {
        if (Object.keys(checkedForRemoval).length > 0) {
            const selectedForRemoval = Object.keys(checkedForRemoval).filter(key => checkedForRemoval[key]);
            var data = selectedStakeholders.filter(unit => selectedForRemoval.includes(unit._id.toString()))
            for (let d of data) {
                removeProgram(d)
            }
            setSelectedStakeholders(prevState => prevState.filter(unit => !selectedForRemoval.includes(unit._id.toString())));
            setCheckedForRemoval({});
        } else {
            toastRef.current.showToast({
                type: 'error',
                message: "Atleast One " + props.linkStakeholderData.stakeholderLinkTab + " Should Be Selected"
            });
        }

        // const selectedForRemoval = Object.keys(checkedForRemoval).filter(key => checkedForRemoval[key]);
        // let data = stakeholderDetails.data.filter(item => item._id == selectedForRemoval[0])
        // if (data) {
        //     removeProgram(data)
        // }
        // setSelectedStakeholders(prevState => prevState.filter(unit => !selectedForRemoval.includes(unit._id.toString())));
        // setCheckedForRemoval({});
    };

    const handlePrevious = () => {
        setCurrentIndex(prevIndex => (prevIndex > 0 ? prevIndex - 1 : selectedStakeholders.length - 1));
    };

    const handleNext = () => {
        setCurrentIndex(prevIndex => (prevIndex < selectedStakeholders.length - 1 ? prevIndex + 1 : 0));
    };

    useEffect(() => {
        if(currentIndex >= 0) {
            getCurrentStakeholderIndex(stakeholderDetails)
        }
    }, [currentIndex])

    const getCurrentStakeholderIndex = (data) => {
        const currentStakeholder = selectedStakeholders[currentIndex];
        setCurrentStakeholderIndex(data?.data?.findIndex(unit => unit?._id === currentStakeholder?._id));
    };

    // const currentStakeholderIndex = getCurrentStakeholderIndex();

    const parseDateString = (dateString) => {
        if (dateString) {
            const [day, month, year] = dateString.split('-').map(Number);
            return new Date(year, month - 1, day); // Month is 0-indexed in JavaScript Date
        }
    };

    // Format the Date object to "dd-mm-yyyy" format
    const formatDate = (input) => {
        const date = (input instanceof Date) ? input : new Date(input);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    // const handleDateChange = (date) => {
    //     setStakeData(prevState => ({
    //         ...prevState,
    //         summary: {
    //             ...prevState.summary,
    //             [fieldKey]: {
    //                 ...prevState.summary[fieldKey],
    //                 text: date ? moment(date).format('DD-MM-YYYY') : ''
    //             }
    //         }
    //     }));
    // };

    const renderFooter = (a) => {
        return (
            <div className="cancel-footer">
                <div className='align-center justify-end pb-0'>
                    <ButtonElement type="submit" className="save-button" onClick={handleAddSelectedStakeholders} label={_.find(props.linkStakeholderData.clientSectionsLinkStakeholder, { section_name: "Associated Stakeholder" })?.section_name} />
                </div>
            </div>
        );
    }

    return (
        <div className='new-field'>
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            {
                _.find(props.linkStakeholderData.clientAssociatedStakeholderFrame, { table_name: "Associated Stakeholder" })?.status &&
                <div className="w-50 box-border">
                    <div className="form-group row align-items-center mb-0">
                        <div className="col-md-6 pl-0">
                            <p className="label-text">
                                {_.find(props.linkStakeholderData?.clientAssociatedStakeholderFrame, { table_name: "Associated Stakeholder" })?.display_name}
                            </p>
                        </div>
                        <div className="col pr-0 d-flex justify-end">
                            <ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={removeAssociatedStakeholders} />
                            <ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={loadAssociatedStakeholders} />
                        </div>
                    </div>
                    <div>
                        {
                            selectedStakeholders.length > 0 && selectedStakeholders?.map((unit, index) => (
                                <div className='new-field'>
                                    <div className="form-group row align-items-center mb-0 mt-0">
                                        <div className='col pr-0 d-flex' key={unit._id}>
                                            <CheckboxElement
                                                id={unit._id}
                                                name={unit.client_name}
                                                // value={unit.client_name}
                                                checked={checkedForRemoval[unit._id] || false}
                                                onChangeCheck={(e) => handleRemovalCheckboxChange(unit._id, e.target.checked)}
                                                className="mr-2"
                                            />
                                            <a className="form-label-text text-left mr-20 pointer mar-l-5" onClick={(e) => setCurrentIndex(index)}>{unit.client_name}</a>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            }

            {
                selectedStakeholders.length > 0 && (
                    <>
                        <div className="form-group row align-items-center mb-0 mt-20">
                            <div className="col-md-8 pl-0 pt-17">
                                <p className="sub-label-text">
                                    {selectedStakeholders[currentIndex]?.client_name}
                                </p>
                            </div>
                            <div className="col pr-0 d-flex justify-end">
                                <ButtonElement className="edit-option-button" type="button" icon="pi pi-chevron-left" onClick={handlePrevious} />
                                <ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-chevron-right" onClick={handleNext} />
                            </div>
                        </div>
                        {
                            stakeholderDetails && Object.entries(newModule).map(([key, value]) => (
                                <div key={key} className='mt-10'>
                                    <Accordion activeIndex={0}>
                                        {
                                            <AccordionTab header={value} disabled>
                                                {
                                                    key == 'obj1' &&
                                                    <div className="new-field d-flex">
                                                        <div className='col-md-6 pl-0'>
                                                            {
                                                                _.find(props.linkStakeholderData?.clientFieldsNew, { field_name: "Client Name" })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.linkStakeholderData?.clientFieldsNew, { field_name: "Client Name" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{stakeholderDetails?.data[currentStakeholderIndex]?.client_name}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.linkStakeholderData?.clientFieldsNew, { field_name: "Client Type" })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.linkStakeholderData?.clientFieldsNew, { field_name: "Client Type" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{stakeholderDetails?.data[currentStakeholderIndex]?.client_type[0]?.label}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: "Client Description" })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: "Client Description" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{stakeholderDetails?.data[currentStakeholderIndex]?.summary?.client_desc}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.linkStakeholderData?.commonFields, { field_name: "Main Board Sponsor" })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.linkStakeholderData?.commonFields, { field_name: "Main Board Sponsor" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{stakeholderDetails?.data[currentStakeholderIndex]?.main_board_sponsor}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.linkStakeholderData?.commonFields, { field_name: "Relationship Owner" }).field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.linkStakeholderData?.commonFields, { field_name: "Relationship Owner" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{stakeholderDetails?.data[currentStakeholderIndex]?.relationship_owner}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.linkStakeholderData?.clientFieldsNew, { field_name: "Client Classification" })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.linkStakeholderData?.clientFieldsNew, { field_name: "Client Classification" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{stakeholderDetails?.data[currentStakeholderIndex]?.client_classification[0]?.label}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                        <div className='col-md-6 pl-0'>
                                                            {
                                                                _.find(props.linkStakeholderData?.clientFieldsNew, { field_name: "Client Status" })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.linkStakeholderData?.clientFieldsNew, { field_name: "Client Status" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{stakeholderDetails?.data[currentStakeholderIndex]?.client_status}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: "Cross Sell Projects" })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: "Cross Sell Projects" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        {
                                                                            _.find(stakeholderDetails?.data[currentStakeholderIndex]?.summary?.cross_sell_opportunities) != null &&
                                                                            <label className="form-label text-left">{stakeholderDetails?.data[currentStakeholderIndex]?.summary?.cross_sell_opportunities[0]?.label}</label>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.linkStakeholderData?.commonFields, { field_name: "Primary Sector" })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.linkStakeholderData?.commonFields, { field_name: "Primary Sector" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{stakeholderDetails?.data[currentStakeholderIndex]?.sector[0]?.label}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: "Client Alert Flag" })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: "Client Alert Flag" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <RadioElement
                                                                            id="client_alert"
                                                                            options={[{ key: 'yes', name: "Yes" }, { key: 'no', name: "No" }]}
                                                                            value={stakeholderDetails?.data[currentStakeholderIndex]?.client_alert_flag?.radio}
                                                                            className="radio-group-class" // Add any additional classes if necessary
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    key == 'obj2' &&
                                                    <div className="new-field w-50">
                                                        {
                                                            _.find(props.linkStakeholderData?.commonFields, { field_name: 'Business Unit' })?.field_status === true &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.linkStakeholderData?.commonFields, { field_name: 'Business Unit' })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <label className="form-label text-left">{stakeholderDetails?.data[currentStakeholderIndex]?.bid_team.business_units_involved[0]?.label}</label>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.linkStakeholderData?.commonFields, { field_name: 'Region' })?.field_status === true &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.linkStakeholderData?.commonFields, { field_name: 'Region' })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <label className="form-label text-left">{stakeholderDetails?.data[currentStakeholderIndex]?.bid_team.region[0]?.label}</label>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: 'Client Team List' })?.field_status === true &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: 'Client Team List' })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <label className="form-label text-left">{stakeholderDetails?.data[currentStakeholderIndex]?.bid_team.client_team_list[0]?.label}</label>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                                {
                                                    key == 'obj3' &&
                                                    <form>
                                                        <div className="new-field w-50">
                                                            {
                                                                _.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: "Mobilisation date" })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: "Mobilisation date" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0 d-flex'>
                                                                        <RadioElement
                                                                            id="mobilisation_date"
                                                                            options={[{ key: 'est', name: "Est" }, { key: 'act', name: "Act" }]}
                                                                            value={stakeholderDetails?.data[currentStakeholderIndex]?.summary?.mobilisation_date?.radio}
                                                                            className="radio-group-class" // Add any additional classes if necessary
                                                                            disabled
                                                                        />
                                                                        <CalendarElement
                                                                            id="mobilisation_date"
                                                                            className='ml-10'
                                                                            value={stakeholderDetails?.data[currentStakeholderIndex]?.summary?.mobilisation_date?.text}
                                                                            onChange={(e) => { e.value instanceof Date ? (setValue('summary.mobilisation_date.text', formatDate(e.value.toLocaleDateString()), trigger('summary.mobilisation_date.text'))) : setValue('summary.mobilisation_date.text', e.value); trigger('summary.mobilisation_date.text') }}
                                                                            maxLength="50"
                                                                            placeholder="Date"
                                                                            autocomplete="off"
                                                                            register={register('summary.mobilisation_date.text')}
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: "Plan Start date" })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: "Plan Start date" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0 d-flex'>
                                                                        <RadioElement
                                                                            id="plan_start_date"
                                                                            options={[{ key: 'est', name: "Est" }, { key: 'act', name: "Act" }]}
                                                                            value={stakeholderDetails?.data[currentStakeholderIndex]?.summary?.plan_start_date?.radio}
                                                                            className="radio-group-class" // Add any additional classes if necessary
                                                                            disabled
                                                                        />
                                                                        <CalendarElement
                                                                            id="plan_start_date"
                                                                            className='ml-10'
                                                                            value={stakeholderDetails?.data[currentStakeholderIndex]?.summary?.plan_start_date?.text}
                                                                            onChange={(e) => { e.value instanceof Date ? (setValue('summary.plan_start_date.text', formatDate(e.value.toLocaleDateString()), trigger('summary.plan_start_date.text'))) : setValue('summary.plan_start_date.text', e.value); trigger('summary.plan_start_date.text') }}
                                                                            maxLength="50"
                                                                            placeholder="Date"
                                                                            autocomplete="off"
                                                                            register={register('summary.plan_start_date.text')}
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: "Plan End date" })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: "Plan End date" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0 d-flex'>
                                                                        <RadioElement
                                                                            id="plan_end_date"
                                                                            options={[{ key: 'est', name: "Est" }, { key: 'act', name: "Act" }]}
                                                                            value={stakeholderDetails?.data[currentStakeholderIndex]?.summary?.plan_end_date?.radio}
                                                                            className="radio-group-class" // Add any additional classes if necessary
                                                                            disabled
                                                                        />
                                                                        <CalendarElement
                                                                            id="plan_end_date"
                                                                            className='ml-10'
                                                                            value={stakeholderDetails?.data[currentStakeholderIndex]?.summary?.plan_end_date?.text}
                                                                            onChange={(e) => { e.value instanceof Date ? (setValue('summary.plan_end_date.text', formatDate(e.value.toLocaleDateString()), trigger('summary.plan_end_date.text'))) : setValue('summary.plan_end_date.text', e.value); trigger('summary.plan_end_date.text') }}
                                                                            maxLength="50"
                                                                            placeholder="Date"
                                                                            autocomplete="off"
                                                                            register={register('summary.plan_end_date.text')}
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: "Total Income Potential" })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: "Total Income Potential" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0 d-flex'>
                                                                        <RadioElement
                                                                            id="total_income_potentiall"
                                                                            options={[{ key: 'est', name: "Est" }, { key: 'act', name: "Act" }]}
                                                                            value={stakeholderDetails?.data[currentStakeholderIndex]?.summary?.total_income_potentiall?.radio}
                                                                            className="radio-group-class" // Add any additional classes if necessary
                                                                            disabled
                                                                        />
                                                                        <InputTextElement
                                                                            id="total_client_spent"
                                                                            className='w-full'
                                                                            onChange={(e) => { setValue('summary.total_income_potentiall.text', e.target.value); trigger('summary.total_income_potentiall.text') }}
                                                                            value={stakeholderDetails?.data[currentStakeholderIndex]?.summary?.total_income_potentiall?.text}
                                                                            maxLength="50"
                                                                            placeholder="Amount"
                                                                            autocomplete="off"
                                                                            register={register('summary.total_income_potentiall.text', { validate: (value) => { return value === undefined || value === null || value === '' || /^[0-9]*$/.test(value) || 'Total Income Potential should be numeric'; } })}
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: "Margin %" })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: "Margin %" })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0 d-flex'>
                                                                        <RadioElement
                                                                            id="margin"
                                                                            options={[{ key: 'est', name: "Est" }, { key: 'act', name: "Act" }]}
                                                                            value={stakeholderDetails?.data[currentStakeholderIndex]?.summary?.margin?.radio}
                                                                            className="radio-group-class" // Add any additional classes if necessary
                                                                            disabled
                                                                        />
                                                                        <InputTextElement
                                                                            id="total_client_spent"
                                                                            className='w-full'
                                                                            onChange={(e) => setValue('summary.margin', e.target.value)}
                                                                            value={stakeholderDetails?.data[currentStakeholderIndex]?.summary?.margin?.text}
                                                                            maxLength="50"
                                                                            placeholder="Amount"
                                                                            // autocomplete="off"
                                                                            register={register('summary.margin.text', { validate: (value) => { return value === undefined || value === null || value === '' || /^[0-9]*$/.test(value) || 'Total Income Potential should be numeric'; } })}
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </form>
                                                }
                                                {
                                                    key == 'obj4' &&
                                                    <div className="new-field d-flex">
                                                        <div className='col-md-6 pl-0'>
                                                            {
                                                                _.find(props.linkStakeholderData?.commonFields, { field_name: 'Internal Hours to Date' })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.linkStakeholderData?.commonFields, { field_name: 'Internal Hours to Date' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{stakeholderDetails?.data[currentStakeholderIndex]?.commercial?.internal_hours_to_date}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.linkStakeholderData?.commonFields, { field_name: 'Internal Cost to Date' })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.linkStakeholderData?.commonFields, { field_name: 'Internal Cost to Date' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{stakeholderDetails?.data[currentStakeholderIndex]?.commercial?.internal_cost_to_date}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.linkStakeholderData?.commonFields, { field_name: 'External Cost to Date' })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.linkStakeholderData?.commonFields, { field_name: 'External Cost to Date' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{stakeholderDetails?.data[currentStakeholderIndex]?.commercial?.external_cost_to_date}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: 'Total Cost to Date' })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: 'Total Cost to Date' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{stakeholderDetails?.data[currentStakeholderIndex]?.commercial?.total_cost_to_date}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: 'Potential income per office' })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: 'Potential income per office' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{stakeholderDetails?.data[currentStakeholderIndex]?.commercial?.potential_office}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                        <div className='col-md-6 pl-0'>
                                                            {
                                                                _.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: 'Potential income per region' })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: 'Potential income per region' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{stakeholderDetails?.data[currentStakeholderIndex]?.commercial?.potential_region}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: 'Potential income per Sector' })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: 'Potential income per Sector' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{stakeholderDetails?.data[currentStakeholderIndex]?.commercial?.potential_sector}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: 'Our income VS Total Client Spent' })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: 'Our income VS Total Client Spent' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{stakeholderDetails?.data[currentStakeholderIndex]?.commercial?.our_income_VS_total_client_spent}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                _.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: 'Total Client Spent' })?.field_status === true &&
                                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                                    <div className="col-md-4 pl-0">
                                                                        <label className="form-label text-left">{_.find(props.linkStakeholderData?.clientFieldsSummary, { field_name: 'Total Client Spent' })?.display_name}:</label>
                                                                    </div>
                                                                    <div className='col pr-0'>
                                                                        <label className="form-label text-left">{stakeholderDetails?.data[currentStakeholderIndex]?.commercial?.total_client_spent}</label>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                            </AccordionTab>
                                        }
                                    </Accordion>
                                </div>
                            ))
                        }
                    </>
                )}
            <Dialog
                visible={isModelOpen}
                breakpoints={{ "960px": "75vw", "641px": "90vw" }}
                header={_.find(props.linkStakeholderData?.clientSectionsLinkStakeholder, { section_name: "Associated Stakeholder" })?.display_name}
                modal
                position="right"
                onHide={closeProgrammDialog}
                footer={renderFooter()}
                className="width-32"
                draggable={false}
            >
                <div className='new-field'>
                    {
                        _.find(props.linkStakeholderData.clientFieldsLinkStakeholder, { field_name: "Select Stakeholder" })?.field_status &&
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className='col pr-0'>
                                <label className="fs-16 fw-600 mar-b-3">
                                    {_.find(props.linkStakeholderData?.clientFieldsLinkStakeholder, { field_name: "Select Stakeholder" })?.display_name}
                                </label>
                                {
                                    stakeholderDetails?.data?.map((unit, index) => (
                                        <div key={unit._id} className='d-flex pt-10'>
                                            <CheckboxElement
                                                id={unit._id}
                                                name={unit.client_name}
                                                value={unit.client_name}
                                                checked={checkedCheckboxes[unit._id] || false}
                                                onChangeCheck={(e) => handleCheckboxChange(unit._id, e.target.checked)}
                                                className="mr-2"
                                            />
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    }
                </div>
            </Dialog>
        </div>
    )

}